module.exports = __webpack_public_path__ + "static/media/1087535.6446d6cf.svg";